import React, { useEffect, useMemo, useState } from 'react';
import { Alert, Button, Col, Container, Row, Spinner } from 'react-bootstrap';
import { useAuth } from '../components/auth/AuthProvider';
import { getServices } from '../controllers/services';

function splitParagraphs(text) {
  if (!text) return [];
  return text
    .split(/\n\s*\n/g)
    .map(t => t.trim())
    .filter(Boolean);
}

function ServiciosPage() {
  const { token } = useAuth();
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const activeServices = useMemo(() => services.filter(s => s.active), [services]);

  useEffect(() => {
    document.title = 'FAMA - Servicios';
    loadServices();
  }, []);

  async function loadServices() {
    setLoading(true);
    setError(null);
    try {
      const data = await getServices();
      setServices(data);
    } catch (e) {
      setError('No se pudieron cargar los servicios en este momento.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Container className='public-page-container servicios-page'>
      <h1>Servicios</h1>
      {loading && <div className='py-5 text-center'><Spinner animation='border' /></div>}
      {error && <Alert variant='danger'>{error}</Alert>}

      {!loading && !error && activeServices.length === 0 && (
        <Alert variant='info'>No hay servicios publicados en este momento.</Alert>
      )}

      {!loading && !error && activeServices.map((service, idx) => {
        const imageSrc = service.imageUrl;
        const imageColumn = idx % 2 === 1 ? { order: 'last', span: 4 } : 4;
        return (
          <Row key={service.id}>
            <Col md={imageColumn}>
              {imageSrc && <img src={imageSrc} alt={service.label} />}
            </Col>
            <Col md={8}>
              <h2>{service.label}</h2>
              {service.subtitle && <h3>{service.subtitle}</h3>}
              {splitParagraphs(service.content).map((paragraph, paragraphIndex) => (
                <p key={`${service.id}-p-${paragraphIndex}`}>{paragraph}</p>
              ))}
              {token && service.documents?.length > 0 && (
                <p>
                  {service.documents.slice(0, 2).map((doc, docIndex) => (
                    <Button
                      key={doc.id}
                      size='lg'
                      className={docIndex === 0 ? 'me-3' : ''}
                      href={doc.url}
                      target='_blank'
                    >
                      {doc.title || `Documento ${docIndex + 1}`}
                    </Button>
                  ))}
                </p>
              )}
            </Col>
          </Row>
        );
      })}
    </Container>
  );
}

export default ServiciosPage;
